import { useNavigate } from "react-router-dom";
import api from "../configs/api";
import { showError } from "../utils/toastUtils";

export const useFlowManager = () => {
  const navigate = useNavigate();

  const handlePostPropertyClick = (isLoggedIn) => {
    if (!isLoggedIn) {
      localStorage.setItem("redirectAfterLogin", "/post-property");
      navigate("/post-property-login");
      return;
    }
    navigate("/post-property");
  };

  const handleLoginSuccess = () => {
    const redirect = localStorage.getItem("redirectAfterLogin");
    navigate(redirect || "/");
    localStorage.removeItem("redirectAfterLogin");
  };

  const commitProperty = async () => {
    try {
      const draft = localStorage.getItem("payloadDraft");
      const payload = draft ? JSON.parse(draft) : null;

      if (!payload) {
        // showError("No property data found. Please try again.");
        navigate("/post-property");
        return false;
      }
      console.log("posted property:", payload);

      await api.post(`/properties`, payload);

      localStorage.removeItem("payloadDraft");
      localStorage.removeItem("selectedPlan");
      localStorage.removeItem("postPropertyDraft"); 

      return true;
    } catch (error) {
      showError(error?.response?.data?.message || "Something went wrong");
      return false;
    }
  };

  const goToChoosePlan = (draft) => {
    if (draft) {
      localStorage.setItem("payloadDraft", JSON.stringify(draft));
    }
    navigate("/choose-plan");
  };

  const handlePlanSelection = async (plan) => {
    localStorage.setItem("selectedPlan", plan);

    if (plan === "Starter") {
      const ok = await commitProperty();
      if (ok) navigate("/post-success", { replace: true });
      return;
    }

    navigate("/payment", { replace: true });
  };

  const goToPaymentSuccess = () => {
    navigate("/payment-success", { replace: true });
  };

  const goToPostSuccess = async () => {
    const ok = await commitProperty();
    if (ok) navigate("/post-success", { replace: true });
  };

  const goToDashboard = () => {
    navigate("/admin/properties", { replace: true });
  };

  return {
    handlePostPropertyClick,
    handleLoginSuccess,
    goToChoosePlan,
    handlePlanSelection,
    goToPaymentSuccess,
    goToDashboard,
    goToPostSuccess,
  };
};

// import { useNavigate } from "react-router-dom";

// export const useFlowManager = () => {
//   const navigate = useNavigate();

//   const goToLoginWithRedirect = (redirectTo) => {
//     localStorage.setItem("redirectAfterLogin", redirectTo);
//     navigate("/post-property-login");
//   };

//   const handlePostPropertyClick = (isLoggedIn) => {
//     if (!isLoggedIn) {
//       goToLoginWithRedirect("/post-property");
//       return;
//     }
//     navigate("/post-property");
//   };

//   const handleLoginSuccess = () => {
//     const redirect = localStorage.getItem("redirectAfterLogin");
//     navigate(redirect || "/");
//     localStorage.removeItem("redirectAfterLogin");
//   };

//   const goToChoosePlan = () => navigate("/choose-plan");

//   const goToPaymentSuccess = () => navigate("/post-success");

//   const goToDashboard = () => navigate("/admin/properties");

//   return {
//     handlePostPropertyClick,
//     handleLoginSuccess,
//     goToChoosePlan,
//     goToPaymentSuccess,
//     goToDashboard,
//   };
// };
